import axiosService from "services/axios.service";

const API_URL = process.env.REACT_APP_URL_API;

const BASE_API_URL = `${API_URL}/v1/admin`;

export const updateAllowToSubscribeSubscription = async (
  allowToSubscribeSubscription: boolean
): Promise<any> => {
  const response = await axiosService.put(
    `${BASE_API_URL}/contributor-subscription-pool/update-allow-subscribe-subscription`,
    { allowToSubscribeSubscription }
  );
  return response?.data?.data?.data;
};
